import { Templates } from '@hellohair/types';

/**
 * Helpers for the array-shaped step fields. All of them return a new array so
 * the draft state stays immutable - the previous editors mutated in place.
 */
export function replaceAt<T>(list: T[] | undefined, i: number, patch: Partial<T>): T[] {
  return (list ?? []).map((entry, index) => (index === i ? { ...entry, ...patch } : entry));
}

export function removeAt<T>(list: T[] | undefined, i: number): T[] {
  return (list ?? []).filter((_entry, index) => index !== i);
}

export function appendTo<T>(list: T[] | undefined, entry: T): T[] {
  return [...(list ?? []), entry];
}

export function setAt<T>(list: T[] | undefined, i: number, value: T): T[] {
  return (list ?? []).map((entry, index) => (index === i ? value : entry));
}

/** `accept` is persisted as a bare string on older templates. */
export const normaliseAccept = <T extends Templates.StepDataLegal>(step: T): T => ({
  ...step,
  accept: Array.isArray(step.accept) ? step.accept : step.accept ? [step.accept] : [],
});
